import { createFeatureSelector, createSelector } from '@ngrx/store';

import { CollectionState } from '../../../domain/models/collection.state';

export const selectCollectionState = createFeatureSelector<CollectionState>('collection');

export const getCollectionList = createSelector(selectCollectionState, (state: CollectionState) => state?.collectionList);

export const collectionLoaded = createSelector(selectCollectionState, (state: CollectionState) => state?.collectionLoaded);

export const getUniqueCachedSlugList = createSelector(selectCollectionState, (state: CollectionState) => {
    return state?.uniqueCachedSlugList;
});
